import axiosClient from '../axiosClient';

// Types
export interface GlobalAdminResponse {
  objectId: string;
  displayName: string;
  email: string;
}

export interface AddGlobalAdminRequest {
  objectId: string;
}

export interface IsGlobalAdminResponse {
  isGlobalAdmin: boolean;
  setupSessionId?: string | null;
}

export interface ClaimFirstGlobalAdminRequest {
  setupSessionId: string;
}

/**
 * Sjekk om brukeren er Global Admin
 */
export async function checkGlobalAdmin (signal?: AbortSignal): Promise<boolean> {
  const response = await axiosClient.get<boolean>('user/global-admin/check', { signal });
  return response.data;
}

/**
 * Sjekk Global Admin status med full respons (inkludert setupSessionId for first-time setup)
 */
export async function checkGlobalAdminStatus (signal?: AbortSignal): Promise<IsGlobalAdminResponse> {
  const response = await axiosClient.get<IsGlobalAdminResponse>('user/global-admin/check', { signal });
  return response.data;
}

/**
 * Claim første Global Admin ved first-time setup
 */
export async function claimFirstGlobalAdmin (
  request: ClaimFirstGlobalAdminRequest,
  signal?: AbortSignal
): Promise<GlobalAdminResponse> {
  const response = await axiosClient.post<GlobalAdminResponse>(
    'user/global-admin/claim-first',
    request,
    { signal }
  );
  return response.data;
}

/**
 * Hent alle Global Admins
 */
export async function getGlobalAdmins (signal?: AbortSignal): Promise<GlobalAdminResponse[]> {
  const response = await axiosClient.get<GlobalAdminResponse[]>('user/global-admin', { signal });
  return response.data;
}

/**
 * Legg til Global Admin
 */
export async function addGlobalAdmin (request: AddGlobalAdminRequest, signal?: AbortSignal): Promise<GlobalAdminResponse> {
  const response = await axiosClient.post<GlobalAdminResponse>('user/global-admin', request, { signal });
  return response.data;
}

/**
 * Fjern Global Admin
 */
export async function removeGlobalAdmin (objectId: string, signal?: AbortSignal): Promise<void> {
  await axiosClient.delete(`user/global-admin/${objectId}`, { signal });
}

